import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export function DealSavingInProgress() {
  const { t } = useTranslation();

  return (
    <Grid
      container
      sx={{
        py: 8,
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h3" data-test="deal-create-loader-header" gutterBottom>
        {t('Saving in progress')}
      </Typography>
      <Typography
        variant="body1"
        data-test="deal-create-loader-body"
        color="textSecondary"
        sx={{
          textAlign: 'center',
        }}
      >
        {t('Please wait. The deal will be published shortly')}
      </Typography>
      <CircularProgress size={20} sx={{ marginTop: 1.5 }} />
    </Grid>
  );
}
